import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _AirLine, _Airport, _CommercialCampaign, _CustomerAddress, _TransportGuideLiquidator } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectSiteID } from "../../../admin/configuracion/SiteID/SelectSiteID";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { CitiesEditor } from "../Countries/Cities/CitiesEditor";
import { GuideLiquidator } from "../../../../core/services/dataBean/talentoHumano/GuideLiquidator";
import { GuideLiquidatorSelect } from "./GuideLiquidator/GuideLiquidatorSelect";
import { InputDate } from "../../../theme/Input/InputDate";
import { EditorPriceList } from "../../../Factoty&Production/PriceList/EditorPriceList";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { CostingCenterSelect } from "../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";


export const TransportGuideLiquidator = () => {

    const guideliquidator = useDataBean(_TransportGuideLiquidator);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [Account, setAccount] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        guideliquidator.instance.getTransportGuideLiquidatorCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.CargaProd = (user.DataBeanProperties.ProductFreightCode ?? "") + "-" + (user.DataBeanProperties.ProductFreightName ?? "") + "-" + (user.DataBeanProperties.ProductFreightMeasurementUnitCode ?? "");
                        user.DataBeanProperties.ProdEspecial = (user.DataBeanProperties.ProductSpecialCode ?? "") + "-" + (user.DataBeanProperties.ProductSpecialName ?? "") + "-" + (user.DataBeanProperties.ProductSpecialMeasurementUnitCode ?? "");
                        user.DataBeanProperties.ProdCorreo = (user.DataBeanProperties.ProductMailCode ?? "") + "-" + (user.DataBeanProperties.ProductMailName ?? "") + "-" + (user.DataBeanProperties.ProductMailMeasurementUnitCode ?? "");
                        user.DataBeanProperties.ProdRest = (user.DataBeanProperties.ProductCorpsesCode ?? "") + "-" + (user.DataBeanProperties.ProductCorpsesName ?? "") + "-" + (user.DataBeanProperties.ProductCorpsesMeasurementUnitCode ?? "");
                        user.DataBeanProperties.ProdAnimals = (user.DataBeanProperties.ProductAnimalsCode ?? "") + "-" + (user.DataBeanProperties.ProductAnimalsName ?? "") + "-" + (user.DataBeanProperties.ProductAnimalsMeasurementUnitCode ?? "");
                        user.DataBeanProperties.ProductPolicy = (user.DataBeanProperties.ProductProductPolicyCode ?? "") + "-" + (user.DataBeanProperties.ProductProductPolicyName ?? "") + "-" + (user.DataBeanProperties.ProductProductPolicyMeasurementUnitCode ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        guideliquidator.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        guideliquidator.instance.deleteTransportGuideLiquidator(guideliquidator.bean.IDTransportGuideLiquidator).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        guideliquidator.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDTransportGuideLiquidator', visible: true },
        { title: 'Tipo de Liquidación', property: 'LiquidateTypeName', visible: true },
        { title: 'Fecha Inicio', property: 'FromDate', visible: true },
        { title: 'Fecha Hasta', property: 'UptoDate', visible: true },
        { title: 'Lista de Precios', property: 'PriceListName', visible: true },
        { title: 'Mínimo Valor de Carga', property: 'MinimumFreightValue', visible: true },
        { title: 'Peso Mínimo Carga', property: 'MinimumWeight', visible: true },
        { title: 'Peso Máximo Carga', property: 'MaximumWeight', visible: true },
        { title: 'Mínimo Valor de Correo', property: 'MinimumMailValue', visible: true },
        { title: 'Mínimo Valor Especial', property: 'MinimumSpecialValue', visible: true },
        { title: '% Seguro', property: 'PolicyPercent', visible: true },
        { title: 'Mínimo Valor Declarado', property: 'MinimumGoodsValue', visible: true },
        { title: 'Máximo Valor Declarado', property: 'MaximumGoodsValue', visible: true },
        { title: 'Valor Kilo Adicional', property: 'AddittionalKgValue', visible: true },
        { title: 'Mínimo Peso Especial (KG)', property: 'MinimumSpecialWeight', visible: true },
        { title: 'Maximo Valor Animales', property: 'MaximumAnimalsValue', visible: true },
        { title: 'Valor Peso Restos (KG)', property: 'CorpsesKgValue', visible: true },
        { title: '% de Kilo de Armas', property: 'KgPercentFireArms', visible: true },
        { title: 'Salario Mínimo', property: 'MinimumSalaryValue', visible: true },
        { title: 'Producto Carga', property: 'CargaProd', visible: true },
        { title: 'Producto Especial', property: 'ProdEspecial', visible: true },
        { title: 'Producto Correo', property: 'ProdCorreo', visible: true },
        { title: 'Producto Restos', property: 'ProdRest', visible: true },
        { title: 'Producto Carga Animales', property: 'ProdAnimals', visible: true },
        { title: 'Producto Póliza ', property: 'ProductPolicy', visible: true },
        { title: 'Centro de Costo Seguro', property: 'PolicyCostingCenter', visible: true },
        { title: 'Unidad de Negocio', property: 'IDBusinessCore', visible: true },
        { title: 'Tarifa única', property: 'SingleRate', visible: true },
        { title: 'Clase Java Liquidaror', property: 'ClassForName', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Modelos de Liquidación de Guías de Transporte de Carga">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={guideliquidator.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <GuideLiquidatorSelect idSelector={guideliquidator.bean.LiquidateType} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "LiquidateType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="FromDate" label="Fecha de inicio" value={guideliquidator.bean.FromDate} setDate={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "FromDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="UptoDate" label="Fecha Hasta" value={guideliquidator.bean.UptoDate} setDate={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Clase Java Liquidaror</label>
                                <input type="text" name="ClassForName" className="form-control" value={guideliquidator.bean.ClassForName} onChange={guideliquidator.handleChange} />
                            </div>
                            <div className="col-md-12">
                                <EditorPriceList onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDPriceList": e.IDPriceList }) }} label="Listado de precios" />
                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Valor de Carga</label>
                                <input type="text" name="MinimumFreightValue" className="form-control" value={guideliquidator.bean.MinimumFreightValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumFreightValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Peso Mínimo Carga</label>
                                <input type="text" name="MinimumWeight" className="form-control" value={guideliquidator.bean.MinimumWeight} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumWeight": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Peso Máximo Carga</label>
                                <input type="text" name="MaximumWeight" className="form-control" value={guideliquidator.bean.MaximumWeight} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MaximumWeight": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Valor de Correo</label>
                                <input type="text" name="MinimumMailValue" className="form-control" value={guideliquidator.bean.MinimumMailValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumMailValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Valor Especial</label>
                                <input type="text" name="MinimumSpecialValue" className="form-control" value={guideliquidator.bean.MinimumSpecialValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumSpecialValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>% Seguro</label>
                                <input type="text" name="PolicyPercent" className="form-control" value={guideliquidator.bean.PolicyPercent} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "PolicyPercent": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Valor Declarado</label>
                                <input type="text" name="MinimumGoodsValue" className="form-control" value={guideliquidator.bean.MinimumGoodsValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumGoodsValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Máximo Valor Declarado</label>
                                <input type="text" name="MaximumGoodsValue" className="form-control" value={guideliquidator.bean.MaximumGoodsValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MaximumGoodsValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor Kilo Adicional</label>
                                <input type="text" name="AddittionalKgValue" className="form-control" value={guideliquidator.bean.AddittionalKgValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "AddittionalKgValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Mínimo Peso Especial (KG)</label>
                                <input type="text" name="MinimumSpecialWeight" className="form-control" value={guideliquidator.bean.MinimumSpecialWeight} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumSpecialWeight": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Maximo Valor Animales</label>
                                <input type="text" name="MaximumAnimalsValue" className="form-control" value={guideliquidator.bean.MaximumAnimalsValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MaximumAnimalsValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Valor Peso Restos (KG)</label>
                                <input type="text" name="CorpsesKgValue" className="form-control" value={guideliquidator.bean.CorpsesKgValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "CorpsesKgValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>% de Kilo de Armas</label>
                                <input type="text" name="KgPercentFireArms" className="form-control" value={guideliquidator.bean.KgPercentFireArms} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "KgPercentFireArms": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Salario Mínimo</label>
                                <input type="text" name="MinimumSalaryValue" className="form-control" value={guideliquidator.bean.MinimumSalaryValue} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "MinimumSalaryValue": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto Carga" renderValue={guideliquidator.bean.ProductFreightName} value={guideliquidator.bean.IDProductFreight} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDProductFreight": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto Especial" renderValue={guideliquidator.bean.ProductSpecialName} value={guideliquidator.bean.IDProductSpecial} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDProductSpecial": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto Correo" renderValue={guideliquidator.bean.ProductMailName} value={guideliquidator.bean.IDProductMail} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDProductMail": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto Restos" renderValue={guideliquidator.bean.ProductCorpsesName} value={guideliquidator.bean.IDProductCorpses} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDProductCorpses": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto Carga Animales" renderValue={guideliquidator.bean.ProductAnimalsName} value={guideliquidator.bean.IDProductAnimals} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDProductAnimals": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <SelectProductEditor label="Producto Póliza" renderValue={guideliquidator.bean.ProductPolicy} value={guideliquidator.bean.IDProductPolicy} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDProductPolicy": e.IDProduct }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Tarifa única</label>
                                <input type="text" name="SingleRate" className="form-control" value={guideliquidator.bean.SingleRate} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "SingleRate": e.target.value }) }} />
                            </div>
                            {/* <div className="col-md-12">
                                <SelectAccountantTree label="Cuenta de Resultado" jsonCode={guideliquidator.bean.PolicyAccountantIDStr} onChange={(e: any) => { guideliquidator.setBean({ ...guideliquidator.bean, "PolicyAccountantIDStr": e.JsonCode }) }} />
                            </div> */}
                            {/* <div className="col-md-12">
                                <CostingCenterSelect label="Centro de Costo" idSelector={guideliquidator.bean.PolicyCostingCenter} onChange={(e) => { guideliquidator.setBean({ ...guideliquidator.bean, "PolicyCostingCenter": e }) }} />
                            </div> */}
                            <div className="col-md-12">
                                <SelectBusinessCore label="Unidad de Negocio" idSelector={guideliquidator.bean.IDBusinessCore} onChange={(e) => { guideliquidator.setBean({ ...guideliquidator.bean, "IDBusinessCore": e }) }} />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {guideliquidator.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}